module.exports = __webpack_public_path__ + "static/media/var4.8c3ee0fc.svg";